<script lang="ts" setup>
defineProps<{
  title: string
}>()
</script>

<template>
  <h1 class="!mb-0 text-[28px] font-medium leading-none text-black md:text-[44px] md:leading-normal">
    {{ title }}
  </h1>
</template>
